import {aCloseDialog} from '@modifi/plugin-dialogs'
import {connect} from '@modifi/redux'

import PreunderwritingSubmitConfirmationDialog from './PreunderwritingSubmitConfirmationDialog'
import {aSubmitPreOnboarding} from './store'
import {selectCompanyExternalId} from '../../../../../data/company'

export const DIALOG_NAME = 'introduction/buyer-details/preunderwriting-submit-confirmation-dialog'

const mapStateToProps = (state: Record<string, any>): {externalCompanyId: string} => ({
  externalCompanyId: selectCompanyExternalId(state) || '',
})

const mapDispatchToProps = {
  submitDialog: aSubmitPreOnboarding,
  closeDialog: aCloseDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(PreunderwritingSubmitConfirmationDialog)
